/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import { selectEditMode } from "../../slices/editMode/editModeSlice";
import { resourceUpdated, selectAllResources, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import { changeTopNavigationElements } from "../../slices/navigationPanel/navigationPanelSlice";
import { selectCurrentUserAdmin, selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { changeComparativeEvidenceMap, selectComparativeEvidenceMap } from "../../slices/comparativeEvidenceMap/comparativeEvidenceMapSlice";
import { loadTopSections, selectAllTopSections, selectTopSectionsStatus, topSectionAdded } from "../../slices/topSections/topSectionsSlice";
import createNetBenefitCalculator from "../compositionResourceFunctions/createNetBenefitCalculatorAPI";
import jsonEquals from "../../functions/jsonEquals";
import updateElement, { updateNarrativeElement } from "../../functions/updateElement";
import getNetEffectPointEstimate from "../compositionResourceFunctions/getNetEffectPointEstimate";
import getNetEffectEstimate from "../compositionResourceFunctions/getNetEffectEstimate";
import generateNarrativeFromSummaryOfFindingsTable from "../compositionResourceFunctions/generateNarrativeFromSummaryOfFindingsTable";
import { ReorganizeSectionsModal } from "../ReorderCompositionSections";
import SummaryOfNetEffectTable from "./SummaryOfNetEffectTable";
//import HealthImpactForestPlotColorful from "./HealthImpactForestPlotColorful";
//import HealthImpactForestPlot from "./HealthImpactForestPlot";
import ColorSchemeToggle from "../../components/ColorSchemeToggle";
import HealthImpactForestPlotEnhanced from "./HealthImpactForestPlotEnhanced";
import NarrativeEntry, { DisplayFromFHIRXhtml } from "../../datatypeComponents/NarrativeEntry";
import TopSectionSliceDisplay from "./TopSectionSliceDisplay";
import { simpleDisplayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import ReferenceEntry, { DisplayFromFHIRReference, displayStringFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "../../datatypeComponents/MarkdownEntry";
import StringEntry from "../../datatypeComponents/StringEntry";
import Spinner from "../../components/Spinner";
import createCompositionTableDict from "../compositionResourceFunctions/createCompositionTableDict";


const CreateNetBenefitCalculator = ({ foi, setNetBenefitCalculatorState, setCompositionResourceState }) => {

    const createNetBenefitCalculatorLink = async () => {
        setCompositionResourceState(prevState => {
            let oldRelatesTo = [];
            if (prevState.relatesTo) {
                oldRelatesTo = JSON.parse(JSON.stringify(prevState.relatesTo));
            }
            let newRelatesTo = oldRelatesTo.concat({
                "type": { "text": "Net Benefit Calculator" },
                "targetUri": "https://NetBenefitCalculator.com/" + foi
            });
            return { ...prevState, "relatesTo": newRelatesTo };
        });
        setNetBenefitCalculatorState(true);
    }

    return <>
        <Button style={{ color: "#FFFFFF", width: "240px", float: "left" }}
            className="formButton"
            content="Use the Net Benefit Calculator" positive
            onClick={() => {
                createNetBenefitCalculatorLink();
            }}
        />
    </>
}

const SummaryOfNetEffectDisplay = ({ foi }) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const isAdmin = useSelector(selectCurrentUserAdmin);
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));
    const comparativeEvidenceMap = useSelector(selectComparativeEvidenceMap);
    const resourceCollection = useSelector(state => selectAllResources(state));
    const allTopSections = useSelector(selectAllTopSections);
    const topSectionsStatus = useSelector(selectTopSectionsStatus);
    const sections = allTopSections.map(entity => { return entity.revisedSection });

    const [compositionResourceState, setCompositionResourceState] = useState({});
    const [generatedNarrativeState, setGeneratedNarrativeState] = useState("");
    const [editSectionModal, setEditSectionModal] = useState({ "openModal": false });
    const [sectionNavigationElementIds, setSectionNavigationElementIds] = useState([]);
    const [sectionsReorganizedState, setSectionsReorganizedState] = useState({});
    const [addSectionState, setAddSectionState] = useState({
        "sectionTitle": "", "addSectionClicked": false
    });
    const [remountTable, setRemountTable] = useState(0);
    const [findingsSectionIndexState, setFindingsSectionIndexState] = useState(null);
    const [netEffectEstimateSectionIndexState, setNetEffectEstimateSectionIndexState] = useState(null);
    const [subjectState, setSubjectState] = useState({});
    const [netBenefitCalculatorIntroductionState, setNetBenefitCalculatorIntroductionState] = useState({});
    const [hasDesirabilityRatingsState, setHasDesirabilityRatingsState] = useState(false);
    const [netBenefitCalculatorState, setNetBenefitCalculatorState] = useState(false);
    const [editNetBenefitCalculatorState, setEditNetBenefitCalculatorState] = useState({});
    const [containedResourceDictionary, setContainedResourceDictionary] = useState({});

    useEffect(() => {
        if (viewingOlderVersion && olderVersionFhirString) {
            try {
                const olderVersionJson = JSON.parse(olderVersionFhirString);
                setCompositionResourceState(olderVersionJson);
                let topNavigationElements = ["Summary", "Summary Table"];
                let sectionHeaderNavigationElements = [];
                if (Array.isArray(olderVersionJson.section)) {
                    for (const section of olderVersionJson.section) {
                        let sectionCode = section?.code?.coding?.[0]?.display || section?.code?.text || section?.code?.coding?.[0]?.code;
                        let sectionFocus = section?.focus?.display || section?.focus?.reference;
                        let sectionHeader = section.title || sectionCode || sectionFocus || "Unidentified Section";
                        topNavigationElements.push(sectionHeader);
                        sectionHeaderNavigationElements.push(sectionHeader);
                    }
                }
                dispatch(changeTopNavigationElements(topNavigationElements));
                const sectionNavigationIds = sectionHeaderNavigationElements.map(((element) => {
                    let id = element.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-");
                    return id;
                }))
                setSectionNavigationElementIds(sectionNavigationIds);
            } catch {
                alert("Error viewing JSON of older version.");
            }
        } else if (resourceJson?.id) {
            setCompositionResourceState(JSON.parse(JSON.stringify(resourceJson)));
            if (Array.isArray(resourceJson.subject) && resourceJson.subject[0]) {
                setSubjectState({ referenceInstance: resourceJson.subject[0] });
            }
            let netBenefitCalculatorIntroduction = "";
            let netBenefitCalculatorIntroductionWhat = "";
            let netBenefitCalculatorIntroductionForWhom = "";
            let netBenefitCalculatorIntroductionSource = "";
            if (Array.isArray(resourceJson.relatesTo)) {
                for (const relatesTo of resourceJson.relatesTo) {
                    if (relatesTo.type?.text === "Introduction for Net Benefit Calculator") {
                        netBenefitCalculatorIntroduction = relatesTo.targetMarkdown || "";
                    }
                    if (relatesTo.type?.text === "Introduction (What) for Net Benefit Calculator") {
                        netBenefitCalculatorIntroductionWhat = relatesTo.targetMarkdown || "";
                    }
                    if (relatesTo.type?.text === "Introduction (For Whom) for Net Benefit Calculator") {
                        netBenefitCalculatorIntroductionForWhom = relatesTo.targetMarkdown || "";
                    }
                    if (relatesTo.type?.text === "Introduction (Source) for Net Benefit Calculator") {
                        netBenefitCalculatorIntroductionSource = relatesTo.targetMarkdown || "";
                    }
                    if (relatesTo.type?.text === "Net Benefit Calculator" && relatesTo.targetUri) {
                        setNetBenefitCalculatorState(true);
                    }
                }
            }
            if (netBenefitCalculatorIntroduction || netBenefitCalculatorIntroductionWhat ||
                netBenefitCalculatorIntroductionForWhom || netBenefitCalculatorIntroductionSource) {
                setNetBenefitCalculatorIntroductionState({
                    "introduction": netBenefitCalculatorIntroduction,
                    "what": netBenefitCalculatorIntroductionWhat,
                    "forWhom": netBenefitCalculatorIntroductionForWhom,
                    "source": netBenefitCalculatorIntroductionSource
                });
            }
            setSectionsReorganizedState({ "reorganized": false, "section": resourceJson.section ? JSON.parse(JSON.stringify(resourceJson.section)) : [] });
            let topNavigationElements = ["Summary", "Summary Table"];
            let sectionHeaderNavigationElements = [];
            let picoClassifiers = {};
            let populationArray = [];
            let interventionArray = [];
            let comparatorArray = [];
            let outcomeArray = [];
            if (Array.isArray(resourceJson.useContext) && resourceJson.useContext.length > 0) {
                for (const item of resourceJson.useContext) {
                    const code = item?.code.code;
                    if (code === "population" && item.valueCodeableConcept) {
                        populationArray.push({ "concept": item.valueCodeableConcept });
                    }
                    else if (code === "intervention" && item.valueCodeableConcept) {
                        interventionArray.push({ "concept": item.valueCodeableConcept });
                    }
                    else if (code === "comparator" && item.valueCodeableConcept) {
                        comparatorArray.push({ "concept": item.valueCodeableConcept });
                    }
                    else if (code === "outcome-measure" && item.valueCodeableConcept) {
                        outcomeArray.push({ "concept": item.valueCodeableConcept });
                    }
                }
            }
            if (Array.isArray(resourceJson.classification) && resourceJson.classification.length > 0) {
                for (const item of resourceJson.classification) {
                    const code = item?.type?.coding?.[0]?.code;
                    if (code === "population" && item.classifier) {
                        populationArray = item.classifier;
                    }
                    else if (code === "intervention" && item.classifier) {
                        interventionArray = item.classifier;
                    }
                    else if (code === "comparator" && item.classifier) {
                        comparatorArray = item.classifier;
                    }
                    else if (code === "outcome-measure" && item.classifier) {
                        outcomeArray = item.classifier;
                    }
                }
            }
            picoClassifiers = {
                populationArray: populationArray,
                interventionArray: interventionArray,
                comparatorArray: comparatorArray,
                outcomeArray: outcomeArray
            };
            if (Array.isArray(resourceJson.section)) {
                for (const sectionIndex in resourceJson.section) {
                    let section = resourceJson.section[sectionIndex];
                    let sectionCode = section?.code?.coding?.[0]?.display || section?.code?.text || section?.code?.coding?.[0]?.code;
                    let sectionFocus = section?.focus?.display || section?.focus?.reference;
                    let sectionHeader = section.title || sectionCode || sectionFocus || "Unidentified Section";
                    topNavigationElements.push(sectionHeader);
                    sectionHeaderNavigationElements.push(sectionHeader);
                    if (section?.code?.coding?.[0]?.code === "summary-of-findings" &&
                        section.section.length > 0
                    ) {
                        setFindingsSectionIndexState(sectionIndex);
                        let hasDesirabilityRatings = true;
                        for (let outcomeSection of section.section) {
                            if (!outcomeSection.section[1].entry?.[0]) {
                                hasDesirabilityRatings = false;
                            }
                        }
                        if (!(netBenefitCalculatorIntroduction || netBenefitCalculatorIntroductionWhat ||
                            netBenefitCalculatorIntroductionForWhom || netBenefitCalculatorIntroductionSource)) {
                            hasDesirabilityRatings = false;
                        }
                        setHasDesirabilityRatingsState(hasDesirabilityRatings);
                    }
                    if (section?.code?.coding?.[0]?.code === "net-effect-estimate") {
                        setNetEffectEstimateSectionIndexState(sectionIndex);
                    }
                }
            }
            dispatch(changeTopNavigationElements(topNavigationElements));
            const sectionNavigationIds = sectionHeaderNavigationElements.map(((element) => {
                let id = element.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-");
                return id;
            }))
            setSectionNavigationElementIds(sectionNavigationIds);
            let combinedDictionary = {};
            for (const entry of resourceCollection) {
                combinedDictionary[entry.id] = entry.revisedResourceJson;
            }
            if (Array.isArray(resourceJson.contained) && resourceJson.contained.length > 0) {
                let containedResourceDictionary = {};
                for (const item of resourceJson.contained) {
                    combinedDictionary[item.id] = item;
                    const key = "#" + item.id;
                    containedResourceDictionary[key] = item;
                }
                setContainedResourceDictionary(containedResourceDictionary);
            }
            let body = {
                "compositionId": foi,
                "compositionTitle": resourceJson.title || resourceJson.name || parentResourceDetail.displayTitle,
                "researchStudyReference": {},
                "populationReference": {},
                "populationDescriptionGroupReference": {},
                "analyzedGroupReference": {},
                "enrolledGroupReference": {},
                "interventionGroupReference": {},
                "interventionDescriptionReference": {},
                "comparatorGroupReference": {},
                "comparatorDescriptionReference": {},
                "groupAssignmentReference": {},
                "synthesisPopulationReference": {},
                "synthesisInterventionDescriptionReference": {},
                "synthesisComparatorDescriptionReference": {},
                "screenedGroupReference": {},
                "excludedGroupReference": {},
                "groupReferencesDictionary": {},
                "outcomeMeasuresReportReference": {},
                "participantFlowReportReference": {},
                "baselineMeasuresReportReference": {},
                "summaryOfFindingsReference": {},
                "outcomeMeasures": [],
                "baselineMeasures": [],
                "participantFlowMeasures": [],
                "outcomeVariablesListReference": {},
                "participantFlowVariablesListReference": {},
                "baselineVariablesListReference": {},
                "combinedDictionary": combinedDictionary,
                "evidenceDisplayDictionary": {},
                "picoClassifiers": picoClassifiers
            };
            dispatch(changeComparativeEvidenceMap(body));
        }
    }, [resourceJson]);

    useEffect(() => {
        if (topSectionsStatus === "succeeded" && allTopSections?.length > 0 && compositionResourceState &&
            Object.keys(compositionResourceState).length > 0
        ) {
            let newCompositionSection = allTopSections.map(entity => { return entity.revisedSection });
            let tableData = createCompositionTableDict({ section: newCompositionSection });
            if (tableData?.Labels) {
                let netEffectPointEstimate = getNetEffectPointEstimate(compositionResourceState) || null;
                let netEffectEstimate = getNetEffectEstimate(compositionResourceState) || null;
                let generatedNarrative = generateNarrativeFromSummaryOfFindingsTable(tableData,
                    netEffectPointEstimate, netEffectEstimate);
                setGeneratedNarrativeState(generatedNarrative);
            }
            if (editMode && resourceJson &&
                (parentResourceDetail.resourceJson.section || newCompositionSection.length > 1 || newCompositionSection[0])
                && !jsonEquals(parentResourceDetail.revisedResourceJson.section, newCompositionSection)) {
                console.log("resourceUpdate for Composition.section");
                let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
                newResourceDetail.revisedResourceJson.section = newCompositionSection;
                dispatch(resourceUpdated(newResourceDetail));
                setRemountTable(prevState => prevState + 1);
            }
            setEditNetBenefitCalculatorState({
                "title": compositionResourceState.title.replace("Summary of Net Effect: ", ""),
                "category": ""
            });
        }
    }, [allTopSections, compositionResourceState]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateNarrativeElement(compositionResourceState, "text", parentResourceDetail,
                dispatch);
        }
    }, [compositionResourceState.text]);

    useEffect(() => {
        if (subjectState.referenceInstance) {
            setCompositionResourceState(prevState => {
                let newSubject = [];
                if (prevState.subject?.length > 0) {
                    newSubject = JSON.parse(JSON.stringify(prevState.subject));
                }
                if (newSubject[0] !== undefined) {
                    newSubject[0] = subjectState.referenceInstance;
                } else {
                    newSubject.push(subjectState.referenceInstance);
                }
                return {
                    ...prevState,
                    subject: newSubject
                };
            });
        }
    }, [subjectState.referenceInstance]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(compositionResourceState, "subject", "ArrayOfReference", parentResourceDetail,
                dispatch);
        }
    }, [compositionResourceState.subject]);

    useEffect(() => {
        let introductionRelatesTo;
        let introductionWhatRelatesTo;
        let introductionForWhomRelatesTo;
        let introductionSourceRelatesTo;
        if (netBenefitCalculatorIntroductionState.introduction) {
            introductionRelatesTo = {
                "type": { "text": "Introduction for Net Benefit Calculator" },
                "targetMarkdown": netBenefitCalculatorIntroductionState.introduction
            };
        }
        if (netBenefitCalculatorIntroductionState.what) {
            introductionWhatRelatesTo = {
                "type": { "text": "Introduction (What) for Net Benefit Calculator" },
                "targetMarkdown": netBenefitCalculatorIntroductionState.what
            };
        }
        if (netBenefitCalculatorIntroductionState.forWhom) {
            introductionForWhomRelatesTo = {
                "type": { "text": "Introduction (For Whom) for Net Benefit Calculator" },
                "targetMarkdown": netBenefitCalculatorIntroductionState.forWhom
            };
        }
        if (netBenefitCalculatorIntroductionState.source) {
            introductionSourceRelatesTo = {
                "type": { "text": "Introduction (Source) for Net Benefit Calculator" },
                "targetMarkdown": netBenefitCalculatorIntroductionState.source
            };
        }
        setCompositionResourceState(prevState => {
            let newRelatesTo = [];
            if (prevState.relatesTo?.length > 0) {
                newRelatesTo = JSON.parse(JSON.stringify(prevState.relatesTo));

                let introductionRelatesToFound = false;
                let introductionWhatRelatesToFound = false;
                let introductionForWhomRelatesToFound = false;
                let introductionSourceRelatesToFound = false;
                for (let relatesTo of newRelatesTo) {
                    if (relatesTo.type?.text === "Introduction for Net Benefit Calculator") {
                        introductionRelatesToFound = true;
                        relatesTo.targetMarkdown = netBenefitCalculatorIntroductionState.introduction;
                    }
                    if (relatesTo.type?.text === "Introduction (What) for Net Benefit Calculator") {
                        introductionWhatRelatesToFound = true;
                        relatesTo.targetMarkdown = netBenefitCalculatorIntroductionState.what;
                    }
                    if (relatesTo.type?.text === "Introduction (For Whom) for Net Benefit Calculator") {
                        introductionForWhomRelatesToFound = true;
                        relatesTo.targetMarkdown = netBenefitCalculatorIntroductionState.forWhom;
                    }
                    if (relatesTo.type?.text === "Introduction (Source) for Net Benefit Calculator") {
                        introductionSourceRelatesToFound = true;
                        relatesTo.targetMarkdown = netBenefitCalculatorIntroductionState.source;
                    }
                }
                if (!introductionRelatesToFound && introductionRelatesTo) {
                    newRelatesTo.push(introductionRelatesTo);
                }
                if (!introductionWhatRelatesToFound && introductionWhatRelatesTo) {
                    newRelatesTo.push(introductionWhatRelatesTo);
                }
                if (!introductionForWhomRelatesToFound && introductionForWhomRelatesTo) {
                    newRelatesTo.push(introductionForWhomRelatesTo);
                }
                if (!introductionSourceRelatesToFound && introductionSourceRelatesTo) {
                    newRelatesTo.push(introductionSourceRelatesTo);
                }
            } else {
                if (introductionRelatesTo) {
                    newRelatesTo.push(introductionRelatesTo);
                }
                if (introductionWhatRelatesTo) {
                    newRelatesTo.push(introductionWhatRelatesTo);
                }
                if (introductionForWhomRelatesTo) {
                    newRelatesTo.push(introductionForWhomRelatesTo);
                }
                if (introductionSourceRelatesTo) {
                    newRelatesTo.push(introductionSourceRelatesTo);
                }
            }
            return {
                ...prevState,
                relatesTo: newRelatesTo
            };
        });
    }, [netBenefitCalculatorIntroductionState]);

    useEffect(() => {
        if (editMode && resourceJson && netBenefitCalculatorIntroductionState &&
            (netBenefitCalculatorIntroductionState.introduction || netBenefitCalculatorIntroductionState.what ||
                netBenefitCalculatorIntroductionState.forWhom || netBenefitCalculatorIntroductionState.source)
        ) {
            updateElement(compositionResourceState, "relatesTo", "ArrayOfRelatesTo", parentResourceDetail,
                dispatch);
        }
    }, [compositionResourceState.relatesTo]);

    useEffect(() => {
        if (editMode && resourceJson && sectionsReorganizedState.reorganized &&
            Array.isArray(sectionsReorganizedState.section) && sectionsReorganizedState.section.length > 0) {
            setSectionsReorganizedState(prevState => { return { ...prevState, "reorganized": false } });
            let oldCompositionSection = allTopSections.map(entity => { return entity.revisedSection });
            if (!jsonEquals(oldCompositionSection, sectionsReorganizedState.section)) {
                let topSectionArray = sectionsReorganizedState.section.map((section, sectionIndex) => {
                    return {
                        id: sectionIndex,
                        displayTitle: section.title ||
                            simpleDisplayStringFromFHIRCodeableConcept(section.code) ||
                            displayStringFromFHIRReference(section.focus) || "Untitled Section",
                        compositionId: foi,
                        productFamily: "SummaryOfNetEffect",
                        initialSection: section,
                        revisedSection: section
                    };
                });
                let topSectionsBody = { topSections: topSectionArray };
                dispatch(loadTopSections(topSectionsBody));
                console.log("sectionsReorganized so resourceUpdate for Composition.section");
            }
        }
    }, [sectionsReorganizedState]);

    useEffect(() => {
        if (editMode && resourceJson && addSectionState.addSectionClicked &&
            addSectionState.sectionTitle) {
            let sectionLength = allTopSections.length;
            let sectionBody = {
                id: sectionLength,
                displayTitle: addSectionState.sectionTitle,
                compositionId: foi,
                productFamily: "SummaryOfNetEffect",
                initialSection: { "title": addSectionState.sectionTitle },
                revisedSection: { "title": addSectionState.sectionTitle }
            }
            dispatch(topSectionAdded(sectionBody));
            console.log("addSectionState so resourceUpdate for Composition.section");
            setAddSectionState({
                "sectionTitle": "", "addSectionClicked": false
            });
        }
    }, [addSectionState]);

    if (!resourceJson) {
        return <Spinner />;
    }

    return <div style={{ marginTop: "12px" }}>
        {(topSectionsStatus === "succeeded" && allTopSections?.length > 0 &&
            compositionResourceState && Object.keys(compositionResourceState).length > 0
        ) &&
            <>
                <h3 id="summary">Summary</h3>
                <div style={{ marginLeft: "24px" }}>
                    {
                        editMode ?
                            <div>
                                <h4>An overall summary for the Summary of Net Effect Report</h4>
                                <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                                    generatedNarrative={generatedNarrativeState} startCollapsed
                                    startingValue={compositionResourceState.text}
                                    calledFrom={"SummaryOfNetEffectDisplay"}
                                    setResourceState={setCompositionResourceState} />
                                <h4>Subject (consider General Population if default value desired)</h4>
                                <ReferenceEntry elementName="referenceInstance" fieldLabel="Subject"
                                    containedResourceDictionary={containedResourceDictionary}
                                    startingResourceType="Group" referencedResourceTypes={["Group"]}
                                    startingValue={subjectState.referenceInstance} enableCreation={true}
                                    setResourceState={setSubjectState} deletable startCollapsed />
                                <h4>An introduction for use with the Net Benefit Calculator</h4>
                                <h5>Optional text presented before the structured introduction</h5>
                                <MarkdownEntry elementName='introduction'
                                    fieldLabel='Net Benefit Calculator introduction (additional text)'
                                    startingValue={netBenefitCalculatorIntroductionState.introduction}
                                    setResourceState={setNetBenefitCalculatorIntroductionState} />
                                <h5>This Net Benefit Calculator is prepared to help you decide whether or not to ...</h5>
                                <MarkdownEntry elementName='what'
                                    fieldLabel='Net Benefit Calculator introduction (What)'
                                    startingValue={netBenefitCalculatorIntroductionState.what}
                                    setResourceState={setNetBenefitCalculatorIntroductionState} />
                                <h5>The estimated benefits and harms are for people who have ...</h5>
                                <MarkdownEntry elementName='forWhom'
                                    fieldLabel='Net Benefit Calculator introduction (For Whom)'
                                    startingValue={netBenefitCalculatorIntroductionState.forWhom}
                                    setResourceState={setNetBenefitCalculatorIntroductionState} />
                                <h5>The evidence to estimate the benefits and harms comes from ...</h5>
                                <MarkdownEntry elementName='source'
                                    fieldLabel='Net Benefit Calculator introduction (Source)'
                                    startingValue={netBenefitCalculatorIntroductionState.source}
                                    setResourceState={setNetBenefitCalculatorIntroductionState} />
                                {isAdmin && <div>
                                    <h4>Net Benefit Calculator Title and Category</h4>
                                    <div style={{ marginLeft: "24px" }}>
                                        <StringEntry elementName='title'
                                            fieldLabel='Net Benefit Calculator title'
                                            startingValue={editNetBenefitCalculatorState.title}
                                            setResourceState={setEditNetBenefitCalculatorState} />
                                        <StringEntry elementName='category'
                                            fieldLabel='Category (| separator)'
                                            startingValue={editNetBenefitCalculatorState.category}
                                            setResourceState={setEditNetBenefitCalculatorState} />
                                        <Button style={{ color: "#FFFFFF", width: "240px", float: "left" }}
                                            className="formButton"
                                            content="Create/Edit Net Benefit Calculator" positive
                                            onClick={() => {
                                                createNetBenefitCalculator(apiToken, foi, editNetBenefitCalculatorState.title,
                                                    editNetBenefitCalculatorState.category);
                                            }}
                                            disabled={!editNetBenefitCalculatorState.title} />
                                        <p>This button only changes content on NetBenefitCalculator.com</p>
                                    </div>
                                    <br />
                                    <br />
                                </div>}
                            </div>
                            :
                            <>
                                <h4>An overall summary for the Summary of Net Effect Report</h4>
                                {(compositionResourceState.text?.div && compositionResourceState.text.status && compositionResourceState.text.status !== "empty") ?
                                    <DisplayFromFHIRXhtml xhtml={compositionResourceState.text.div} />
                                    : <p>[Narrative summary not generated.]</p>}
                                {compositionResourceState.subject?.[0] &&
                                    <>
                                        <h4>Subject</h4>
                                        <DisplayFromFHIRReference reference={compositionResourceState.subject[0]}
                                            containedResourceJson={compositionResourceState.subject[0].reference &&
                                                containedResourceDictionary[compositionResourceState.subject[0].reference]} />
                                    </>
                                }
                                {(netBenefitCalculatorIntroductionState &&
                                    (netBenefitCalculatorIntroductionState.introduction || netBenefitCalculatorIntroductionState.what ||
                                        netBenefitCalculatorIntroductionState.forWhom || netBenefitCalculatorIntroductionState.source)) &&
                                    <>
                                        {netBenefitCalculatorIntroductionState.introduction &&
                                            <>
                                                <h4>An initial introduction for use with the Net Benefit Calculator</h4>
                                                <DisplayFromFHIRMarkdown markdown={netBenefitCalculatorIntroductionState.introduction} />
                                            </>
                                        }
                                        {netBenefitCalculatorIntroductionState.what &&
                                            <>
                                                <h4>An introduction of what is compared for use with the Net Benefit Calculator</h4>
                                                <DisplayFromFHIRMarkdown markdown={netBenefitCalculatorIntroductionState.what} />
                                            </>
                                        }
                                        {netBenefitCalculatorIntroductionState.forWhom &&
                                            <>
                                                <h4>An introduction of the target population for use with the Net Benefit Calculator</h4>
                                                <DisplayFromFHIRMarkdown markdown={netBenefitCalculatorIntroductionState.forWhom} />
                                            </>
                                        }
                                        {netBenefitCalculatorIntroductionState.source &&
                                            <>
                                                <h4>An introduction of the evidence source for use with the Net Benefit Calculator</h4>
                                                <DisplayFromFHIRMarkdown markdown={netBenefitCalculatorIntroductionState.source} />
                                            </>
                                        }
                                    </>}
                            </>
                    }
                </div>
                <h3 id="summary-table">Summary Table</h3>
                <>
                    {hasDesirabilityRatingsState === true &&
                        <>
                            <div>
                                {netBenefitCalculatorState ?
                                    <div>
                                        <Link to={"https://NetBenefitCalculator.com/" + foi} ><h4>Use the Net Benefit Calculator</h4></Link>
                                        &nbsp;&nbsp;
                                        <p>&nbsp;&nbsp;An interactive form which does not alter the publicly available content and lets you modify the relative importance of outcomes with your personal values.</p>
                                    </div>
                                    :
                                    <div>{editMode && <>
                                        <CreateNetBenefitCalculator foi={foi}
                                            setNetBenefitCalculatorState={setNetBenefitCalculatorState}
                                            setCompositionResourceState={setCompositionResourceState} />
                                        &nbsp;&nbsp;
                                        <p>&nbsp;&nbsp;An interactive form which does not alter the publicly available content and lets you modify the relative importance of outcomes with your personal values.</p>

                                    </>}
                                    </div>
                                }
                            </div>
                            <br />
                            <br />
                        </>}
                    <SummaryOfNetEffectTable key={remountTable}
                        containedResourceDictionary={containedResourceDictionary}
                        subject={compositionResourceState.subject?.[0]}
                        findingsSectionIndex={findingsSectionIndexState}
                        netEffectEstimateSectionIndex={netEffectEstimateSectionIndexState} />
                </>
                <br />
                <ColorSchemeToggle />
                <br />
                <HealthImpactForestPlotEnhanced key={remountTable + "Forest"}
                    allTopSections={allTopSections} />
                {editMode && <div>
                    <Button className="formButton" style={{ margin: "0px", /*color: "#000000", */ }}
                        content="Reorganize Sections" compact
                        onClick={() => { setEditSectionModal({ "openModal": true }) }} />
                    <br />
                </div>}
                {(editSectionModal.openModal) &&
                    <>
                        <ReorganizeSectionsModal
                            editSectionModal={editSectionModal}
                            setEditSectionModal={setEditSectionModal}
                            sectionsReorganizedState={sectionsReorganizedState}
                            setSectionsReorganizedState={setSectionsReorganizedState}
                        />
                    </>}
                <div>
                    {sections && <>
                        {(sections?.length > 0) &&
                            sections.map((section, sectionIndex) => {
                                return <div key={sectionIndex}>
                                    <TopSectionSliceDisplay foi={foi} containedResourceDictionary={containedResourceDictionary}
                                        setCompositionResourceState={setCompositionResourceState}
                                        sectionIndex={sectionIndex}
                                        resourceReferenceMap={comparativeEvidenceMap}
                                        sectionNavigationElementIds={sectionNavigationElementIds} />
                                    <br />
                                </div>
                            })}
                        {editMode &&
                            <>
                                <Button style={{ color: "#000000", width: "130px", float: "left" }}
                                    className="formButton"
                                    content="+ Add Section"
                                    onClick={() => {
                                        setAddSectionState({
                                            "sectionTitle": "Replace with Proper Section Title",
                                            "addSectionClicked": true
                                        });
                                    }}
                                />
                            </>}
                    </>}
                </div>
            </>}
    </div>
}

export default SummaryOfNetEffectDisplay;